module.exports = __webpack_public_path__ + "static/media/contest_logo.be44bf72.png";